import { render, staticRenderFns } from "./dybb.vue?vue&type=template&id=899d240a&"
import script from "./dybb.vue?vue&type=script&lang=js&"
export * from "./dybb.vue?vue&type=script&lang=js&"
import style0 from "./dybb.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports